var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicnicWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 12.1811C22.9999 11.6517 22.5695 11.2186 22.0434 11.2186H17.0217L15.7304 6.8875H19.1304C19.6827 6.8875 20.1304 6.43978 20.1304 5.8875V4.9625C20.1304 4.43311 19.7 4 19.1739 4H4.82603C4.29992 4 3.8695 4.43311 3.8695 4.9625V5.8875C3.8695 6.43978 4.31722 6.8875 4.8695 6.8875H8.2695L6.97818 11.2186H1.95652C1.43042 11.2186 1 11.6517 1 12.1811V13.1061C1 13.6584 1.44772 14.1061 2 14.1061H6.16522L4.97027 18.1143C4.7791 18.7556 5.25945 19.4 5.92859 19.4H6.30217C6.75684 19.4 7.15429 19.0933 7.26952 18.6534L8.46087 14.1061H15.4914L16.6827 18.6534C16.798 19.0933 17.1954 19.4 17.6501 19.4H18.0237C18.6928 19.4 19.1732 18.7556 18.982 18.1143L17.787 14.1061H21.9999C22.5522 14.1061 23 13.6583 22.9999 13.106L22.9999 12.1811ZM9.27372 11.2186L10.4215 6.8875H13.6737L14.8215 11.2186H9.27372Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicnicWhite);
export default __webpack_public_path__ + "static/media/picnic-white.39afa3ad617d66b879df278c787abe4f.svg";
export { ForwardRef as ReactComponent };